module.exports = __webpack_public_path__ + "static/media/BSC-white-large.db476da8.png";